export default function ProtectedRoute({ element }) {
  const isAuthenticated = !!localStorage.getItem("jwt");

  if (!isAuthenticated) return (window.location.href = "/login");

  return isAuthenticated && element;
}
